import { CollectionsProvider } from "./CollectionsProvider";
import { AppContent } from "./AppContent";
import { useVersionChecker } from "../../utils/useVersionChecker";
import { UpdateAvailableDialog } from "../UpdateAvailableDialog";

export const Root = () => {
    const { updateAvailable, refreshAllTabs } = useVersionChecker();

    return (
        <CollectionsProvider>
            <AppContent />
            <UpdateAvailableDialog open={updateAvailable} onRefresh={refreshAllTabs} />
        </CollectionsProvider>
    );
};
